import { Injectable } from '@angular/core';
import { NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { finalize, map } from 'rxjs/operators';
import { cloneDeep } from 'lodash';

import { ModalService } from '@app/core/modal.service';
import { ModalResult, AddMfaModalComponent as ModalComponent } from './add-mfa-modal.component';

type CustomNgbModalRef = NgbModalRef & { beforeDismiss?: () => boolean };

@Injectable({ providedIn: 'root' })
export class AddMfaModalService {
  constructor(private modalService: ModalService) {}

  open(options?: NgbModalOptions & { beforeDismiss?: never }) {
    const newOptions: NgbModalOptions = cloneDeep(options || {});
    newOptions.windowClass = (newOptions.windowClass || '')
      .split(/\s+/)
      .concat('sidemodal-right')
      .join(' ');

    // Allows beforeDismiss option to magically work from inside the component
    let modalInstance: CustomNgbModalRef;
    const subscription = this.modalService.activeInstances
      .pipe(map(items => items.find(item => item.componentInstance instanceof ModalComponent)?.componentInstance))
      .subscribe({ next: (instance: CustomNgbModalRef) => (modalInstance = instance) });

    newOptions.beforeDismiss = () => {
      if (typeof modalInstance?.beforeDismiss === 'function') {
        return modalInstance.beforeDismiss();
      }
      return true;
    };

    return this.modalService.open<ModalResult>(ModalComponent, null, newOptions).pipe(finalize(() => subscription.unsubscribe()));
  }
}
